import { render, staticRenderFns } from "./transferCenterVehicleConfirm.vue?vue&type=template&id=e52b3c06&scoped=true"
import script from "./transferCenterVehicleConfirm.vue?vue&type=script&lang=js"
export * from "./transferCenterVehicleConfirm.vue?vue&type=script&lang=js"
import style0 from "./transferCenterVehicleConfirm.vue?vue&type=style&index=0&id=e52b3c06&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52b3c06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e52b3c06')) {
      api.createRecord('e52b3c06', component.options)
    } else {
      api.reload('e52b3c06', component.options)
    }
    module.hot.accept("./transferCenterVehicleConfirm.vue?vue&type=template&id=e52b3c06&scoped=true", function () {
      api.rerender('e52b3c06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Operation/transferCenterConfirm/transferCenterVehicleConfirm.vue"
export default component.exports